import React from 'react';

import type { ISVGElement } from 'components/icons/types';

export const ExclamationIcon = (props: ISVGElement) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="#38A5FF" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_14:6171)">
      <path
        d="M8 6.99382e-07C3.58172 1.08564e-06 -1.08564e-06 3.58172 -6.99382e-07 8C-3.13124e-07 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C15.9952 3.58369 12.4163 0.00478156 8 6.99382e-07ZM8.66666 12C8.66666 12.3682 8.36819 12.6667 8 12.6667C7.63181 12.6667 7.33334 12.3682 7.33334 12L7.33334 6.66666C7.33334 6.29847 7.63181 6 8 6C8.36819 6 8.66666 6.29847 8.66666 6.66666L8.66666 12V12ZM8 4C7.63181 4 7.33334 3.70153 7.33334 3.33334C7.33334 2.96516 7.63181 2.66669 8 2.66669C8.36819 2.66669 8.66665 2.96516 8.66665 3.33334C8.66665 3.70153 8.36819 4 8 4Z"
      />
    </g>
    <defs>
      <clipPath id="clip0_14:6171">
        <rect width="16" height="16" fill="white" transform="translate(16 16) rotate(180)" />
      </clipPath>
    </defs>
  </svg>
);
